import { render, staticRenderFns } from "./vpPoster.vue?vue&type=template&id=f715db42&scoped=true&"
import script from "./vpPoster.vue?vue&type=script&lang=js&"
export * from "./vpPoster.vue?vue&type=script&lang=js&"
import style0 from "./vpPoster.vue?vue&type=style&index=0&id=f715db42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f715db42",
  null
  
)

export default component.exports